import React from "react";
import styles from "./EventCard.module.scss";
import eventImage from "../../../assets/images/event-image.jpg";

const EventCard = () => {
  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <div className={styles.image}>
        <img src={eventImage} alt="Title Of The Event" />
      </div>
      <div className={styles.info}>
        <h2 className={styles.title}>Title Of The Event</h2>
        <div className={styles.date}>05-24 Nov, 2024</div>
        <div className={styles.location}>
          <span>#Paris</span>
          <span>#France</span>
        </div>
        <p className={styles.description}>
          Contrary to popular belief, Lorem Ipsum is not simply random text. It
          has roots in a piece of classical Latin literature from 45 BC, making
          it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure
          Latin words, consectetur.
        </p>
        <div className={styles.readMore}>
          <button>Read More</button>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
